import React from 'react';

import Filters from '../../common/Filters/Filters';

interface Props {
  filters: Record<string, string>;
  setFilter: (filter: string, value: string) => void;
}

const CitiesFilters = ({ filters, setFilter }: Props) => (
  <Filters
    className="d-flex flex-column gap-3 align-items-stretch"
    values={filters}
    setFilter={setFilter}
    filtersSchema={{
      name: { type: 'input', placeholder: 'Название' },
      municipality: { type: 'input', placeholder: 'Муниципалитет' },
    }}
  />
);

export default CitiesFilters;
